import { render, staticRenderFns } from "./MyAccount.vue?vue&type=template&id=a8695c1a&scoped=true&"
import script from "./MyAccount.vue?vue&type=script&lang=ts&"
export * from "./MyAccount.vue?vue&type=script&lang=ts&"
import style0 from "./MyAccount.vue?vue&type=style&index=0&id=a8695c1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8695c1a",
  null
  
)

export default component.exports